"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var disabled_1 = __importDefault(require("src/utilities/styled/disabled"));
var fill_1 = __importDefault(require("src/utilities/styled/fill"));
var round_1 = __importDefault(require("src/utilities/styled/round"));
var margin_1 = __importDefault(require("src/utilities/styled/margin"));
var utilities_1 = require("src/components/Inputs/utilities");
var makeBorder_1 = __importDefault(require("src/components/Inputs/utilities/makeBorder"));
var makeBackground_1 = __importDefault(require("src/components/Inputs/utilities/makeBackground"));
var makePlaceholder_1 = __importDefault(require("src/components/Inputs/utilities/makePlaceholder"));
var makeResize_1 = __importDefault(require("./utilities/makeResize"));
var makeTextArea = function (Component) {
    return (0, styled_components_1.default)(Component).attrs(function (_a) {
        var _b = _a.round, round = _b === void 0 ? 1 : _b;
        return ({
            round: round,
        });
    })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    ", "\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    padding: ", ";\n    height: 100%;\n\n    ::placeholder {\n      ", ";\n    }\n\n    &:hover,\n    &:focus {\n      ", ";\n    }\n  "], ["\n    ", ";\n    ", "\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    padding: ", ";\n    height: 100%;\n\n    ::placeholder {\n      ", ";\n    }\n\n    &:hover,\n    &:focus {\n      ", ";\n    }\n  "])), utilities_1.baseStyles, makeBackground_1.default, fill_1.default, disabled_1.default, makeResize_1.default, function (_a) {
        var messageType = _a.messageType;
        return (0, makeBorder_1.default)({ active: false, messageType: messageType });
    }, round_1.default, margin_1.default, function (_a) {
        var theme = _a.theme;
        return theme.inputs.textarea.padding[0] + " " + theme.inputs.textarea.padding[1];
    }, makePlaceholder_1.default, function (_a) {
        var messageType = _a.messageType;
        return (0, makeBorder_1.default)({ active: true, messageType: messageType });
    });
};
exports.default = makeTextArea;
var templateObject_1;
